import React, { useEffect, createElement } from 'react';
import { Hero } from './components/Hero';
import { StorySection } from './components/StorySection';
import { MistakesSection } from './components/MistakesSection';
import { DeliverablesSection } from './components/DeliverablesSection';
import { AudienceSection } from './components/AudienceSection';
import { StepsSection } from './components/StepsSection';
import { ProofSection } from './components/ProofSection';
import { FAQSection } from './components/FAQSection';
import { BonusSection } from './components/BonusSection';
import { OfferSection } from './components/OfferSection';
import { Footer } from './components/Footer';
declare global {
  interface Window {
    fbq: any;
    _fbq: any;
  }
}
export function App() {
  useEffect(() => {
    // Meta Pixel initialization
    if (!window.fbq) {
      const n: any = window.fbq = function () {
        n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
      };
      if (!window._fbq) window._fbq = n;
      n.push = n;
      n.loaded = true;
      n.version = '2.0';
      n.queue = [];
      const t = document.createElement('script');
      t.async = true;
      t.src = 'https://connect.facebook.net/en_US/fbevents.js';
      document.head.appendChild(t);
    }
    window.fbq('init', '776524068662312');
    window.fbq('track', 'PageView');
    // Set page title
    document.title = 'Protocolo SOS 72H';
  }, []);
  return <div className="min-h-screen font-sans text-gray-800 bg-cream selection:bg-sage selection:text-white" data-id="element-0">
      <Hero data-id="element-1" />
      <StorySection data-id="element-2" />
      <MistakesSection data-id="element-3" />
      <DeliverablesSection data-id="element-4" />
      <AudienceSection data-id="element-5" />
      <StepsSection data-id="element-6" />
      <ProofSection data-id="element-7" />
      <FAQSection data-id="element-8" />
      <BonusSection data-id="element-9" />
      <OfferSection data-id="element-10" />
      <Footer data-id="element-11" />
    </div>;
}